import React from "react";
import { PersonnelTypesCard } from "./PersonnelTypesCard";
import { PersonnelTypesUIProvider } from "./PersonnelTypesUIContext";

export function PersonnelTypesPage({ history }) {
  const personnelTypesUIEvents = {
    openNewPersonnelTypePage: () => {
      history.push("/personel-turleri/ekle");
    },
    openEditPersonnelTypePage: (id) => {
      history.push(`/personel-turleri/duzenle/${id}`);
    },
  };
  
  return (
    <PersonnelTypesUIProvider personnelTypesUIEvents={personnelTypesUIEvents}>
      <PersonnelTypesCard />
    </PersonnelTypesUIProvider>
 );
}